import { render } from "./giveupword.vue?vue&type=template&id=66fb9f29&scoped=true"
import script from "./giveupword.vue?vue&type=script&lang=js"
export * from "./giveupword.vue?vue&type=script&lang=js"

import "./giveupword.vue?vue&type=style&index=0&id=66fb9f29&scoped=true&lang=css"

import exportComponent from "D:\\startup\\gtdhtml5\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fb9f29"]])

export default __exports__